import { CREATETASK_SUCCESS, CREATETASK_FAIL } from "../actionTypes";

const initialState = {
    user: null,
};

const createTaskReducer = (state = initialState, action) => {
    switch (action.type) {
        case CREATETASK_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                user: action.payload,
            };
        case CREATETASK_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: null,
            };
        default:
            break;
    }

    return state;
};

export default createTaskReducer;
